const VerifoneSocketNames = Object.freeze({
    INTEGRATION: 'Integration Socket',
    PROGRESS: 'Progress Socket',
});

module.exports = VerifoneSocketNames;
